import React, { useLayoutEffect, useState } from 'react';
import "../Css/AboutUs.css";
import Footer from "../Component/FooterComponent/Footer";
import { Link } from 'react-router-dom';

const AboutUs = () => {
  const [isStoryExpanded, setIsStoryExpanded] = useState(false);

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  });

  return (
    <>

      {/* section 1  */}
      <section className='about-page-banner-section'>
        <div className='about-page-banner-con'>
          <h2>Our Story</h2>
        </div>
      </section>

      {/* section 2 */}

      <section className='about-page-section-2' id='our-story'>
        <div className='about-page-section-2-main-con'>
          <div className='about-page-section-2-details'>
            <h3>1FIVE</h3>
            <p>Every name has an identity. Ours has an origin.</p>
            <p>1FIVE draws its inspiration from 15 August — India’s Independence Day. The number 1 and the word FIVE come together to create a distinctive name that reflects our origin, individuality and ambition.</p>
            {isStoryExpanded && (
              <>
                <p>Why 1FIVE and not ONE FIVE or ONE5? Because we believe a name should be as distinctive as the identity behind it. The 1 represents our ambition to lead and FIVE completes a name that is uniquely ours.</p>
                <p>Founded on an Indian identity with a global outlook, 1FIVE GLOBAL PVT. LTD. is conceived as a Global Luxury House bringing together carefully curated expressions of luxury across accessories, fragrances, apparel, beverages, art and collectibles.</p>
                <p>We believe luxury is not defined by how widely something is available, but by how exceptionally it is created and how rarely it can be experienced.</p>
                <p>At 1FIVE, we value exceptional quality, distinctive design, craftsmanship and limited availability. We believe in creating with intention rather than producing for volume, and in offering collections selectively rather than being present everywhere.</p>
                <p>Every category carries the same philosophy: individuality, refinement and exclusivity.</p>
                <p>Our ambition is to build an Indian-origin luxury house with an international identity — one that develops its own standards, creates its own desirability and earns its place among the world’s distinguished luxury names.</p>
                <p>1FIVE is not about being everywhere. It is about being somewhere that matters.</p>
              </>
            )}
            <button
              className='about-story-toggle'
              type='button'
              onClick={() => setIsStoryExpanded((expanded) => !expanded)}
              aria-expanded={isStoryExpanded}
            >
              {isStoryExpanded ? 'Show Less' : 'Know More'}
            </button>
          </div>

          <div className='about-page-section-2-image-con'>
            <h3>Store Coming Soon</h3>
          </div>
        </div>
      </section>

      {/* section 3 */}

      <section className='about-page-section-3'>
        <div className='about-page-section-3-details-con'>
          <h3>Get In Touch</h3>
          <h4>For Media Enquiries</h4>
          <h5>For any media or public relations questions, please contact our team at: <a href="mailto:Business@1FIVEglobal.com">
            Business@1FIVEglobal.com
          </a></h5>

        </div>
      </section>

      {/* section 4 */}

      <section className='about-page-section-2'>
        <div className='about-page-section-2-main-con'>
          <div className='about-page-section-2-details'>
            <h2>FEATURED POST</h2>
            {/* <div className='about-page-section-4-tagline'>
              <h3>1 Five has just opened in San Jose, California!</h3>
            </div> */}
            <p>1FIVE is excited to announce that we are planning to open a new store in Mumbai, India, in the next few months.</p>
          </div>
          <div className='about-page-section-4-image-con'>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default AboutUs